import { api } from '@/scripts/api';

export const PartnerApplicationService = {
    getPartnerRequestAgency(options = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/partnerships/v1/partner-application/agency/partner-requests?${options}`;
            api
                .get(service, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },
    getPartnerRequestClient(options = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/partnerships/v1/partner-application/client/partner-requests?${options}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },
    deny(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/partnerships/v1/partner-application/deny';
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        });
    },
    cancel(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/partnerships/v1/partner-application/cancel';
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        });
    },
    revoke(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/partnerships/v1/partner-application/revoke';
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        });
    },
    accept(body) {
        return new Promise((resolve, reject) => {
            api
                .post('/ms/partnerships/v1/partner-application/accept', body)
                .then(resolve)
                .catch(reject);
        });
    },
    create(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/partnerships/v1/partner-application';
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        });
    },
    clientDecline(agencyClientId) {
        return new Promise((resolve, reject) => {
            api
                .delete(`/api/AgencyClients/${agencyClientId}`, null)
                .then(resolve)
                .catch(reject);
        });
    },
    bulkRevoke(body) {
        return new Promise((resolve, reject) => {
            api
                .post('/ms/partnerships/v1/partner-application/bulk-revoke', body)
                .then(resolve)
                .catch(reject);
        });
    },
}